import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { Container } from '../../components/Layouts/Container';

export const OrganizationPageLayout = () => {
  const {
    selectedOrganization,
    isSelectedOrgAdmin,
    loadingIsSelectedOrgAdmin,
    loadingOrganizations,
  } = useAppContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (!loadingIsSelectedOrgAdmin && !loadingOrganizations) {
      if (!selectedOrganization || !isSelectedOrgAdmin) {
        navigate('/', { replace: true });
      }
    }
  }, [
    selectedOrganization,
    isSelectedOrgAdmin,
    loadingIsSelectedOrgAdmin,
    loadingOrganizations,
    navigate,
  ]);

  return (
    <Container
      display="flex"
      justifyContent="center"
      overflow="auto"
      px={0}
      py={0}
    >
      <Outlet />
    </Container>
  );
};
